import { render } from "./BlogsView.vue?vue&type=template&id=7c6c5417"
import script from "./BlogsView.vue?vue&type=script&lang=js"
export * from "./BlogsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__